export default __webpack_public_path__ + "static/media/wise-home-demo-regnskab.94d4b528.zip";